module.exports = __webpack_public_path__ + "img/AQ.2c29afbb.png";